import { useEffect, useState } from "react";
import { toast } from "sonner";
import usePaymentsOverviewService from "../../../api/payments/overview/overview.service";
import { PaymentsOverview } from "../../../api/payments/overview/overview.responses";
import { StatCard } from "./StatCard";
import { PlatformBreakdownCard } from "./PlatformBreakdownCard";
import { TopPromoCodesCard } from "./TopPromoCodesCard";
import { TopPartnersCard } from "./TopPartnersCard";
import { RecentPurchasesCard } from "./RecentPurchasesCard";

function OverviewTab() {
  const { getOverview } = usePaymentsOverviewService();
  const [data, setData] = useState<PaymentsOverview | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getOverview()
      .then((res) => setData(res.data))
      .catch(() => toast.error("Failed to load overview"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16 text-muted-foreground">
        Loading overview…
      </div>
    );
  }

  if (!data) return null;

  const { totals, recentPurchases, byPlatform, topPromos, topPartners } = data;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <StatCard label="Active Accesses" value={totals.activePurchaseAccessCount} />
        <StatCard label="Total Accesses" value={totals.totalPurchaseAccessCount} />
        <StatCard
          label="Promo Redemptions"
          value={
            <>
              {totals.promoApplications.completed}
              <span className="text-sm font-normal text-muted-foreground">
                {" "}/ {totals.promoApplications.total}
              </span>
            </>
          }
        />
        <StatCard
          label="Promo Conversion"
          value={`${totals.promoApplications.conversionRate}%`}
        />
      </div>

      <PlatformBreakdownCard byPlatform={byPlatform} />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <TopPromoCodesCard topPromos={topPromos} />
        <TopPartnersCard topPartners={topPartners} />
      </div>

      <RecentPurchasesCard recentPurchases={recentPurchases} />
    </div>
  );
}

export default OverviewTab;
